var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rect',{class:_vm.interactive ? 'interactive' : '',attrs:{"x":_vm.x,"y":_vm.useTweeningYIfNotFalsy,"width":_vm.width,"height":_vm.useTweeningHeightIfNotFalsy,"fill":_vm.fill}},[(_vm.tooltip !== '')?_c('title',[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }